export const enum AcademySearchSource {
  Documentation = 'documentation',
  Glossary = 'glossary',
  QuickStart = 'quick-start',
}
